<script setup lang="ts">
import RecipeInterline from './RecipeInterline.vue'

import type { RecipeParagraph } from '../../../utils/paragraph-schema/paragraphs'

defineProps<{
  nutritionFacts?: RecipeParagraph['recipe']['nutritionFacts']
}>()
</script>

<template>
  <section class="bx-content bx-content__continuous-text bx-recipe__nutrition bx-typo--content-continuous-text bx-typo--center"
           data-tc="recipe-nutrition">
    <RecipeInterline title="Nährwerte"
                     variant="nutrition" />
    <p v-if="nutritionFacts?.servingUnit">
      <span> Pro {{ nutritionFacts.servingUnit }} </span>
    </p>
    <ul>
      <li v-if="nutritionFacts?.calories">
        {{ nutritionFacts.calories }} kcal
      </li>
      <li v-if="nutritionFacts?.protein">
        {{ nutritionFacts.protein }} g Eiweiß
      </li>
      <li v-if="nutritionFacts?.fat">
        {{ nutritionFacts.fat }} g Fett
      </li>
      <li v-if="nutritionFacts?.carbohydrate">
        {{ nutritionFacts.carbohydrate }} g Kohlenhydrate
      </li>
    </ul>
  </section>
</template>
